class SizeChartModal extends HTMLElement {
  constructor() {
    super();
    this.dialog = null;
    this.openButton = null;
  }

  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.openButton = this.querySelector('[data-open-modal]');
    
    if (!this.dialog || !this.openButton) return;

    this.setupEventListeners();
  }

  setupEventListeners() {
    if (!this.dialog || !this.openButton) return;

    // Open button click
    this.openButton.addEventListener('click', () => this.open());

    // Close button click
    const closeButton = this.dialog.querySelector('[data-close-modal]');
    if (closeButton) {
      closeButton.addEventListener('click', () => this.close());
    }

    // Backdrop click
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) {
        this.close();
      }
    });

    // ESC key
    this.dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });
  }

  open() {
    if (!this.dialog || !this.openButton) return;

    this.dialog.showModal();
    this.openButton.setAttribute('aria-expanded', 'true');
    
    // Set data-state to trigger animation
    this.setAttribute('data-state', 'open');
    this.dialog.setAttribute('data-state', 'open');
  }

  close() {
    if (!this.dialog || !this.openButton) return;

    // Remove data-state to reset animation
    this.removeAttribute('data-state');
    this.dialog.removeAttribute('data-state');
    
    this.dialog.close();
    this.openButton.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('size-chart-modal', SizeChartModal);
